<template>
    <v-container class="justify-center">
        <v-card
        max-width="600px"
          min-width="360px">
            <v-card-title>Forgot Password</v-card-title>
            <v-card-text>
                <div v-if="!messageon">
                <p class="descText">Enter your Memories For Us email address. We will send you an email to change your password.</p>
                <v-text-field label="Email Address" v-model="email"></v-text-field>
                <v-btn small class="primary" @click="sendForgotLink()">Send</v-btn>
                </div>
                <div v-if="messageon">
                   <h3>{{message}}</h3> 
                </div>
            </v-card-text>

      </v-card>

    </v-container>
</template>

<script>
 import EventService from "@/services/EventService.js";

export default {
    name: 'forgot',
     data: () => ({
    email: '',
    messageon:  false,
    message: ''
    }), //end of data

    methods: {
    async sendForgotLink() {
      try {
      await EventService.forgotPassword(this.email)
      .then(() => {
          this.messageon = true;
          this.message = 'Please check your email to continue changing your password.'
      }) //end of es call
      }
      catch(error) {
          console.log(error)
      }      
      }  //end of sendForgotLink
    } //end of methods
}
</script>

<style scoped>
.descText {
    font-size: 1.25em;
}
</style>
